import React, { Component } from "react";
import {
  Jumbotron,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import AnimatedNavbar from "../components/AnimatedNavbar";

class Header extends Component {
  constructor(props) {
    super();
    this.state = {
      isNavOpen: false,
      isModalOpen: false,
      path: props.location,
    };
    this.toggleNav = this.toggleNav.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  toggleNav() {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    });
  }

  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  }

  handleLogin(event) {
    this.toggleModal();
    console.log(
      "Username:" +
        this.username.value +
        " Password:" +
        this.password.value +
        " Remember: " +
        this.remember.checked
    );
    // alert('Username:' + this.username.value + " Password:" + this.password.value + " Remember: " +
    //     this.remember.checked);
    alert("You cannot log in yet.");
    event.preventDefault();
  }

  render() {
    // <React.Fragment> is a react fragment which allows to return more than 1 component without
    //wrapping them in a div , another alias: <>
    return (
      <React.Fragment>
        <AnimatedNavbar
          theme={this.props.currentTheme}
          handleThemeChange={this.props.switchTheme}
          toggleModal={this.toggleModal}
        />
        <Jumbotron>
          <div className="container row-header">
            <div className="col-12 col-sm-6">
              <h1>Abrar's Restaurant</h1>
              <p>
                {" "}
                This is a test restaurant page that illustrates the usage of how
                different components work together in react js using
                React-Redux, Redux-Forms, Redux-Thunk and some other third-party
                libraries.
              </p>
            </div>
          </div>
        </Jumbotron>
        <Modal
          className="modal-custom"
          isOpen={this.state.isModalOpen}
          toggle={this.toggleModal}
          color="black"
        >
          <ModalHeader toggle={this.toggleModal}>Login</ModalHeader>
          <ModalBody>
            <Form onSubmit={this.handleLogin}>
              <FormGroup>
                <Label htmlFor="username">Username</Label>
                <Input
                  type="text"
                  id="username"
                  name="username"
                  innerRef={(input) => {
                    this.username = input;
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="password">Password</Label>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  innerRef={(input) => {
                    this.password = input;
                  }}
                />
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    id="remember"
                    name="remember"
                    innerRef={(input) => {
                      this.remember = input;
                    }}
                  />
                  Remember Me{" "}
                </Label>
              </FormGroup>
              <Button type="submit" value="submit" className="btn">
                Login
              </Button>
            </Form>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Header;
